import m from "../../geodata/es2015/israelPalestineLow";
window.am4geodata_israelPalestineLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/israelPalestineLow.js
// module id = null
// module chunks = 